import React, { CSSProperties, DOMAttributes } from 'react';
import { ScrollType } from '../../components/page-view/types';
import { LayoutType } from '../../constants';
import { PageLayoutType } from '../../constants/pc';
import { StyleConfigAttrs } from '../../utils/page-style/types';
import { TerminalType } from '../types';

export interface MStyledProps extends React.Attributes {
  className?: string;
  wrapperClsName?: string;
  wrapperStyle?: CSSProperties;
  data?: StyleConfigAttrs;
  /** 子级数据: 上左右布局时，左右边栏所需的样式数据 */
  childData?: StyleConfigAttrs;
  pageBgConfig?: StyleConfigAttrs;
  pageId?: string;
  scopeId?: string;
  clientType?: TerminalType;
  mounted?: (dom: HTMLDivElement, event?: any) => void;
  onClick?: (dom?: HTMLDivElement) => void;
  onChange?: () => void;
}

export interface StyledProps extends MStyledProps {
  scrollType?: ScrollType;
  layoutType?: PageLayoutType;
  mount?: () => void;
  // pageView传递给page div的属性
  pageWrapProps?: DOMAttributes<any>;
}

export interface FlowStyledProps extends MStyledProps {}

export interface StyledStates {}

export interface BackgroundMaskProps {
  pageBgConfig?: StyleConfigAttrs;
  clientType?: TerminalType;
  layoutType?: LayoutType;
}

export enum BackgroundType {
  Picture = 'Picture',
  Video = 'Video',
  None = 'None',
}

export enum SizeType {
  FullScreen = 'fullScreen',
  FixedSize = 'fixedSize',
}

export enum FillMode {
  /** 填充 */
  Fill = 'Fill',
  /** 适应 */
  Fit = 'Fit',
  /** 拉伸 */
  Stretch = 'Stretch',
  /** 平铺 */
  Tile = 'Tile',
  /** 居中 */
  Center = 'Center',
}
